import BigPanel from "../../components/BigPanel/BigPanel";

function Datenschutz() {
  return (
    <BigPanel title="Datenschutzerklärung">
      <h2>1. Verantwortlicher</h2>
      <p>
        Christian Schweiger<br />
        Seniweg 2, 82538 Geretsried<br />
        E-Mail: info@fit-to-clean.de
      </p>

      <h2>2. Allgemeines zur Datenverarbeitung</h2>
      <p>
        Wir verarbeiten personenbezogene Daten ausschließlich im Einklang mit den
        Vorgaben der Datenschutz-Grundverordnung (DSGVO) und dem Telekommunikation-
        Telemedien-Datenschutz-Gesetz (TTDSG).
      </p>
      <p>
        Personenbezogene Daten werden nur verarbeitet, soweit dies zur Bereitstellung
        einer funktionsfähigen Website, zur Bearbeitung von Anfragen oder – sofern
        Sie eingewilligt haben – zur Analyse und Optimierung unseres Online-Angebots
        erforderlich ist.
      </p>

      <h2>3. Datenverarbeitung beim Besuch der Website</h2>
      <p>
        Beim Aufruf unserer Website erhebt unser Hosting-Anbieter automatisch
        sogenannte Server-Logfiles (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs,
        Browsertyp, Betriebssystem).
      </p>
      <p>
        Diese Daten dienen ausschließlich der Gewährleistung eines sicheren und
        stabilen Betriebs der Website und werden nicht mit anderen Datenquellen
        zusammengeführt.
      </p>
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
        Die Logfiles werden spätestens nach 7 Tagen gelöscht.
      </p>

      <h2>4. Kontaktaufnahme</h2>
      <p>
        Wenn Sie uns per Kontaktformular, Telefon oder E-Mail kontaktieren, verarbeiten
        wir die von Ihnen mitgeteilten Daten (z. B. Name, E-Mail-Adresse, Inhalt der
        Anfrage), um Ihre Anfrage zu bearbeiten.
      </p>
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) bzw.
        Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Bearbeitung allgemeiner
        Anfragen).
      </p>

      <h2>5. Cookies & Einwilligungsmanagement</h2>
      <p>
        Unsere Website verwendet Cookies und vergleichbare Technologien. Der Einsatz
        erfolgt abhängig von der jeweiligen Kategorie:
      </p>
      <ul>
        <li>
          <strong>Notwendige Cookies:</strong> Erforderlich für den technischen Betrieb
          der Website. Diese werden ohne Einwilligung gesetzt (§ 25 Abs. 2 TTDSG).
        </li>
        <li>
          <strong>Statistik- & Marketing-Cookies:</strong> Werden nur nach Ihrer
          ausdrücklichen Einwilligung gesetzt (§ 25 Abs. 1 TTDSG).
        </li>
      </ul>
      <p>
        Ihre Auswahl können Sie jederzeit über die „Cookie-Einstellungen“ ändern oder
        widerrufen.
      </p>

      <h2>6. Matelso Web Master Plugin (Telefon- & Kontakttracking)</h2>
      <p>
        Wir nutzen das Web Master Plugin der matelso GmbH zur Bereitstellung von
        Telefon- und Kontaktfunktionen sowie zur internen Auswertung von
        Kontaktpunkten.
      </p>
      <p>
        Dabei werden ausschließlich First-Party-Cookies eingesetzt, die auf unserer
        Domain gespeichert werden. Eine Weitergabe der Daten an Dritte oder eine
        Nutzung für externe Werbezwecke erfolgt nicht.
      </p>
      <p>
        Technisch notwendige Funktionen werden ohne Einwilligung bereitgestellt.
        Statistikbezogene Auswertungen erfolgen nur, sofern Sie in die Kategorie
        „Marketing“ eingewilligt haben.
      </p>
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (notwendige Funktionen) sowie
        Art. 6 Abs. 1 lit. a DSGVO i. V. m. § 25 Abs. 1 TTDSG (einwilligungspflichtige
        Statistikfunktionen).
      </p>

      <h2>7. Google Analytics 4 (Statistik)</h2>
      <p>
        Sofern Sie in die Kategorie „Statistik“ eingewilligt haben, setzen wir Google
        Analytics 4 ein, um die Nutzung unserer Website auszuwerten.
      </p>
      <p>
        Google Analytics verwendet Cookies und ähnliche Technologien. Die IP-Adresse
        wird anonymisiert verarbeitet. Die Verarbeitung erfolgt ausschließlich auf
        Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
      </p>
      <p>
        Das Speichern und Auslesen von Informationen auf Ihrem Endgerät erfolgt gemäß
        § 25 Abs. 1 TTDSG.
      </p>

      <h2>8. Google Ads Conversion-Tracking (Marketing)</h2>
      <p>
        Sofern Sie in die Kategorie „Marketing“ eingewilligt haben, nutzen wir Google
        Ads Conversion-Tracking, um den Erfolg unserer Werbemaßnahmen zu messen.
      </p>
      <p>
        Hierbei können Klick- oder Ereignisdaten (z. B. Absenden eines Kontaktformulars)
        erfasst werden. Eine Zusammenführung mit anderen Daten erfolgt nicht.
      </p>
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. a DSGVO sowie § 25 Abs. 1 TTDSG.
      </p>
      <p>
        Weitere Informationen:
        https://policies.google.com/privacy
      </p>

      <h2>9. Auftragsverarbeitung & Empfänger</h2>
      <p>
        Sofern externe Dienstleister eingesetzt werden (z. B. Hosting, IT-Dienstleister),
        erfolgt dies im Rahmen einer Auftragsverarbeitung gemäß Art. 28 DSGVO.
      </p>

      <h2>10. Speicherdauer</h2>
      <p>
        Personenbezogene Daten werden nur solange gespeichert, wie dies für die
        jeweiligen Zwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten
        bestehen.
      </p>

      <h2>11. Rechte der betroffenen Personen</h2>
      <ul>
        <li>Auskunft (Art. 15 DSGVO)</li>
        <li>Berichtigung (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Widerspruch (Art. 21 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
      </ul>

      <h2>12. Datensicherheit</h2>
      <p>
        Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten vor
        Verlust, Manipulation oder unberechtigtem Zugriff zu schützen
        (z. B. TLS-Verschlüsselung).
      </p>

      <h2>13. Aktualität</h2>
      <p>
        Diese Datenschutzerklärung ist aktuell gültig und wird bei rechtlichen oder
        technischen Änderungen angepasst.
      </p>
    </BigPanel>
  );
}

export default Datenschutz;
